module.exports = __webpack_public_path__ + "img/base_be_attacked_3.ca6279f0.png";